module.exports = __webpack_public_path__ + "8669b8706bbbdd1482e2fccc4ed96850.ttf";